module.exports = __webpack_public_path__ + "static/media/gitlab.feef733d.svg";